import React from 'react';
import { Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const DragItemCol = ({
  children,
  draggableClassName,
  className,
  index,
  ...rest
}) => {
  return (
    <Col
      className={`cursor-pointer ${draggableClassName} ${className}`}
      data-index={index}
      {...rest}
    >
      {children}
    </Col>
  );
};

DragItemCol.propTypes = {
  children: PropTypes.node,
  draggableClassName: PropTypes.string,
  className: PropTypes.string,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DragItemCol;
